import React, { useState, useEffect } from "react";
import { Table, Pagination, Checkbox } from "antd";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { set } from "immutable";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";
import { Input } from "antd";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import { FaMinusCircle } from "react-icons/fa";

import { useForm, Controller, Feedback } from "react-hook-form";
import DatePicker from "react-datepicker";

import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import { URL_EMPLOYEE } from "../../constans/servidor";
import PaginationComponent from "../Desenganche/pagination";
import Formulario from "./Formulario";
import { NavItem } from "react-bootstrap";

const TableComponentC = (props) => {
  const { data } = props;
  const [loadingData, setLoadingData] = useState(false);
  const [contracto, setContrato] = useState();
  const [compañia, setCompañia] = useState();
  const [id, setID] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [placa, setPlaca] = useState();
  const [placass, setPlacass] = useState();
  const [estado, setEstado] = useState();
  const [fecha_hora, setFecha_hora] = useState([]);
  const [nom_terminal, setNom_terminal] = useState();
  const [cod_terminal, setCod_terminal] = useState();
  const [cod_park, setCod_park] = useState();
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [buscar, setBuscar] = useState(data);
  const [dplaca, setdPlaca] = useState([]);
  const [dplaca1, setdPlaca1] = useState([]);
  const [dplaca2, setdPlaca2] = useState([]);
  const [dataPagination, setDataPagination] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [objeto, setObjeto] = useState([]);
  const [crear, setCrear] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 800);
  }, []);

  let handleSearch = "";
  let handleRowClick = "";
  let filteredData = "";

  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    console.log("data");
    console.log(data);
    setFilterData(data);
    setTimeout(() => {
      setEstado(1);
    }, 800);
  }, [data]);

  const Datos = async (contracto, compania, id) => {
    setModal(true);
    setContrato(contracto);
    setCompañia(compania);
    setID(id);
  };

  const confirmar = async (data) => {
    setModal(false);

    const parametros = {
      id: id,
    };
    try {
      function reloadPage() {
        window.location.reload();
      }
      const resultado = await axios.post(
        `${URL_EMPLOYEE}/monthlyInstallment/disable/lpr/disableContract`,
        parametros
      );
      if (resultado.data["statusCode"] == 202) {
        toast.success("Contrato Desactivado Exitosamente");
        setInterval(reloadPage, 2000);
      } else {
        toast.error(resultado.data["message"]);
      }
    } catch (error) {
      toast.error("Algo salio mal..");
      setLoadingData(false);
    }
  };

  handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };
  filteredData = dataPagination.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  let filteredResults = filteredData;
  let valor;

  if (filteredResults.length === 0) {
    valor = true;
  }

  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <div>
      {data ? (
        <>
          {!modal1 ? (
            <Row className="justify-content-end mbottom-40">
              <Button
                onClick={() => {
                  setModal1(true);
                }}
                type="buttom"
                variant="primary"
                className=" btn btn-primary mtop-20 boton"
              >
                Crear Contrato
              </Button>
            </Row>
          ) : null}
          {modal1 ? (
            <>
              <Row className="justify-content-end mbottom-40">
                <Button
                  onClick={() => {
                    setModal1(false);
                  }}
                  type="buttom"
                  variant="primary"
                  className=" btn btn-primary mtop-20 boton"
                >
                  Cerrar Formulario
                </Button>
              </Row>
              <Formulario modal={modal1}></Formulario>
            </>
          ) : null}
          <Row className="justify-content-end mbottom-40">
            <input
              className="buscar inputplaca"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </Row>
          <table className="tabla ">
            <thead>
              <tr>
                <th>Id Contrato</th>
                <th>Contrato</th>
                <th>Compañia</th>
                <th>NIT</th>
                <th>Fecha Act</th>
                <th>Fecha Exp</th>
                <th>Codigo Parq</th>
                <th>Cupos</th>
                <th>Cupos Activos</th>
                <th>Inactivar</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row) => (
                <tr>
                  <td>{row.idMonthlyContract}</td>
                  <td>{row.contract}</td>
                  <td>{row.companyName}</td>
                  <td>{row.companyNit}</td>
                  <td>{moment.utc(row.activationDate).format("DD/MM/YYYY")}</td>
                  <td>{moment.utc(row.expirationDate).format("DD/MM/YYYY")}</td>
                  <td>{row.codPark}</td>
                  <td>{row.quotas}</td>
                  <td>{row.quotasUsed}</td>
                  <td>
                    <FaMinusCircle
                      onClick={() =>
                        Datos(
                          row.contract,
                          row.companyName,
                          row.idMonthlyContract
                        )
                      }
                      style={{
                        color: "red",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="float-right pagination">
            <PaginationComponent
              data={data}
              setDataPagination={setDataPagination}
              title="Posts"
              pageLimit={10}
              dataLimit={50}
            />
          </div>
        </>
      ) : null}
      <Modal show={modal} onHide={() => setModal(false)} size="lg">
        <form onSubmit={handleSubmit(confirmar)}>
          <Modal.Header closeButton>
            <Modal.Title className="texto-slogan2">
              Confirmación Desactivación Contrato
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <>
              <form onSubmit={handleSubmit(confirmar)}>
                <Row className="align-items-center">
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <p>El contrato seleccionado fue: </p>
                  </Col>
                </Row>
                <Row>
                  <Col
                    className=" mbottom-40 texto-resaltado"
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                  >
                    *Contrato: {contracto}
                    <br></br>
                    *Compañia: {compañia}
                  </Col>
                </Row>
                <Button
                  type="submit"
                  onClick={() => {
                    setModal(false);
                  }}
                  variant="secondary"
                >
                  Atras
                </Button>
              </form>
            </>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              className=" btn2 btn2-primary  boton"
              variant="primary"
            >
              Desactivar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default TableComponentC;
